<new-ui-global-spinner />
<new-ui-global-confirmation />
<new-ui-global-toast />
@if (
  ENABLE_PROCESS_AI &&
  settings.hasModule("processAgent") &&
  settings.hasAnyPermission([UserPermission.ProcessAdministrator])
) {
  @defer (on idle) {
    <new-ui-process-agent-chat-widget />
  }
}
<router-outlet />
